export default "__VITE_ASSET__eea1wrHH__"